import React, { useState, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import axios from "axios";

function PromotionInput() {
  const [promotionList, setPromotionList] = useState([]);

  const getPromotion = async () => {
    try {
      const res = await axios.get(
        "https://test.bioversalremedies.com/bioversal_remedies_admin/get_promotion"
      );
      setPromotionList(res.data);
    } catch (err) {
      console.log("error: " + err);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getPromotion();
  }, []);

  return (
    <section>
      <div className="container top-margin">
        <h3 className="pro_ducthead">Our Promotional Gifts Range</h3>

        <div className="row my-4">
          {promotionList.length > 0 ? (
            promotionList.map((item, index) => (
              <div className="col-md-4 col-sm-12" key={index}>
                <LazyLoadImage
                  className="product_img1"
                  src={`/assets/images/${item.image}`} // ← dynamic path
                  alt="promotion-image"
                />
              </div>
            ))
          ) : (
            <p>No promotions found.</p>
          )}
        </div>
      </div>
    </section>
  );
}

export default PromotionInput;
